<template>
  <base-layout
    page-default-back-link="/home"
    showUserSettings="true"
    showSettings="true"
  >
    <div v-if="error!==''" class="login_error ion-text-center">{{ error }}</div>

    <!-- Search Module  -->
    <div v-if="status == 'Search'">
      <ion-grid>
        <ion-row>
          <ion-col size="12" size-md="6">
            <ion-searchbar
              placeholder="Search"
              @ionChange="searchStringFn"
              debounce="1000"
              v-model="term"
            ></ion-searchbar>
          </ion-col>
          <ion-col size="12" size-md="3">
            <ion-item>
              <ion-select
                interface="popover"
                :value="searchStatus"
                @ionChange="statusFilterFn"
              >
                <ion-select-option
                  :value="item"
                  v-for="(item, index) in statusList"
                  :key="index"
                  >{{ item }}
                </ion-select-option>
              </ion-select>
            </ion-item>
          </ion-col>
          <ion-col size="12" size-md="3">
            <ion-item>
              <ion-label>All Users</ion-label>
              <ion-toggle
                @ionChange="getAllVisitsToggle"
                value="true"
                :checked="getAllVisits">
              </ion-toggle>
            </ion-item>
<!--             <ion-select
              interface="popover"
              :value="getAllVisits"
              @ionChange="getAllVisitsFn"
            >
              <ion-select-option
                :value="item"
                v-for="(item, index) in getAllVisitsList"
                :key="index"
                >{{ item }}
              </ion-select-option>
            </ion-select> -->
          </ion-col>
        </ion-row>
      </ion-grid>
      <!--<ion-grid>
        <ion-row>
          <ion-col>
            <ion-searchbar placeholder="Search" @ionChange="searchStringFn" debounce="1000" v-model="term" ></ion-searchbar>
          </ion-col>
          <ion-col>
            <ion-select interface="popover" :value="searchStatus" @ionChange="statusFilterFn">
              <ion-select-option
                :value="item"
                v-for="(item, index) in statusList"
                :key="index"
                >{{ item }}</ion-select-option
              >
            </ion-select>
          </ion-col>
        </ion-row>
      </ion-grid>-->

      <ion-list class="results">
        <ion-item v-for="(visit, index) in visits" :key="visit.flvis_id">
          <ion-grid>
            <ion-row>
              <ion-col size="7">
                <div style="display: flex; flex-wrap: wrap">
                  <ion-col size="12" size-md="4">
                    <ion-label>Code: </ion-label>
                    {{ visit.flvis_code }}
                  </ion-col>
                  <ion-col size="12" size-md="4">
                    <div v-for="(person) in visit.persons" :key="person.flvisp_id">
                      <span v-if="person.flvisp_company!=''" ><ion-label>Company: </ion-label>{{ person.flvisp_company }}</span>
                      <span v-if="person.flvisp_first_name!=''" ><ion-label>First: </ion-label>{{ person.flvisp_first_name }}</span>
                      <span v-if="person.flvisp_last_name!=''" ><ion-label>Last: </ion-label>{{ person.flvisp_last_name }}</span>
                      <span v-if="person.flvisp_phone!=''" ><ion-label>Phone: </ion-label>{{ person.flvisp_phone }}</span>
                      <span v-if="person.flvisp_email!=''" ><ion-label>Email: </ion-label>{{ person.flvisp_email }}</span>
                      <span v-if="person.flvisp_website!=''" ><ion-label>Web: </ion-label>{{ person.flvisp_website }}</span>
                      <span v-if="person.flvisp_images!=''" ><ion-label>Card was Added</ion-label></span>
                    </div>
                  </ion-col>
                  <ion-col size="12" size-md="4">
                    <span v-if="visit.flvis_started!='' && visit.flvis_ended!=''">
                      <ion-label>Started: </ion-label>
                      {{ visit.flvis_started }}<br>
                      <ion-label>Finished: </ion-label>
                      {{ visit.flvis_ended }}
                    </span>
                    <span v-if="visit.flvis_started!='' && visit.flvis_ended==''">
                      <ion-label>Started: </ion-label>
                      {{ visit.flvis_started }}<br>
                    </span>
                    <span>
                      <ion-label>Started by: </ion-label>
                      {{ visit.started_by_name }}<br>
                    </span>
                  </ion-col>
                </div>
              </ion-col>
              <ion-col size="5" class="ion-text-right">
                <div style="display: flex; flex-wrap: wrap">
                  <ion-col size="12" size-md="4">
                    <ion-button size="small" @click="show_visit(index)" v-if="visit.flvis_status!='InProgress'" >
                      <ion-icon :icon="eyeOutline"></ion-icon>&nbsp;Open
                    </ion-button>
                    <ion-button size="small" @click="continue_visit(index)" v-if="visit.flvis_status=='InProgress'" >
                      Continue
                    </ion-button>
                  </ion-col>
                  <ion-col size="12" size-md="4" class="ion-text-left">
                    <ion-label>Status: </ion-label>
                    {{ visit.flvis_status }}
                  </ion-col>
                </div>
              </ion-col>
              <ion-col size="12" v-if="visit.showroom_name!=''">
                <div style="display: flex; flex-wrap: wrap">
                  <ion-col size="12" size-md="4">
                    <span>
                      <ion-label>Showroom: </ion-label>
                      {{ visit.showroom_name }}<br>
                    </span>
                  </ion-col>
                  <!--
                  <ion-col size="12" size-md="4">
                    <span>
                      {{ visit.flvis_showroom_data }}<br>
                    </span>
                  </ion-col>
                  -->
                </div>
              </ion-col>
            </ion-row>
          </ion-grid>
        </ion-item>
      </ion-list>

      <div v-if="show_scroll">
        <ion-infinite-scroll
          @ionInfinite="loadData($event, true)"
          threshold="100px"
          id="infinite-scroll"
          :disabled="false"
        >
          <ion-infinite-scroll-content
            loading-spinner="bubbles"
            loading-text="Loading more data..."
          >
          </ion-infinite-scroll-content>
        </ion-infinite-scroll>
      </div>
    </div>

    <!-- View Visit's Information Module  -->
    <div v-if="status == 'Visit_Information'">

      <br>
      <div class="ion-text-right">
        <ion-button size="small" @click="back_to_search(item)">Back</ion-button>
      </div>
      <br>
      <div class="information">
        <ion-grid>
          <ion-row>
            <ion-col size="7" class="ion-no-padding">
              <div style="display: flex; flex-wrap: wrap">
                <ion-col size="12" size-md="4" >
                  <ion-label>Code: </ion-label><br>
                  {{ selected_visit.flvis_code }}
                </ion-col>
                <ion-col size="12" size-md="4">
                  <div v-for="(person) in selected_visit.persons" :key="person.flvisp_id">
                    <span v-if="person.flvisp_company!=''" ><ion-label>Company: </ion-label><br>{{ person.flvisp_company }}<br></span>
                    <span v-if="person.flvisp_first_name!=''" ><ion-label>First: </ion-label><br>{{ person.flvisp_first_name }}<br></span>
                    <span v-if="person.flvisp_last_name!=''" ><ion-label>Last: </ion-label><br>{{ person.flvisp_last_name }}<br></span>
                    <span v-if="person.flvisp_phone!=''" ><ion-label>Phone: </ion-label><br>{{ person.flvisp_phone }}<br></span>
                    <span v-if="person.flvisp_email!=''" ><ion-label>Email: </ion-label><br>{{ person.flvisp_email }}<br></span>
                    <span v-if="person.flvisp_website!=''" ><ion-label>Web: </ion-label><br>{{ person.flvisp_website }}<br></span>
                    <span v-if="person.flvisp_images!=''" ><ion-label>Card was Added</ion-label></span>
                  </div>
                </ion-col>
                <ion-col size="12" size-md="4">
                    <span v-if="selected_visit.flvis_started!='' && selected_visit.flvis_ended!=''">
                      <ion-label>Started: </ion-label><br>
                      {{ selected_visit.flvis_started }}<br>
                      <ion-label>Finished: </ion-label><br>
                      {{ selected_visit.flvis_ended }}
                    </span>
                    <br>
                    <span v-if="selected_visit.flvis_started!='' && selected_visit.flvis_ended==''">
                      <ion-label>Started: </ion-label><br>
                      {{ selected_visit.flvis_started }}<br>
                    </span>
                    <br>
                    <span>
                      <ion-label>Started by: </ion-label>
                      {{ selected_visit.started_by_name }}<br>
                    </span>
                    <br>
                    <span v-if="selected_visit.flvis_processed!=''">
                      <ion-label>Processed: </ion-label><br>
                      {{ selected_visit.flvis_processed }}<br>
                      <strong>by</strong>&nbsp;{{ selected_visit.flvis_processed_by_name }}
                    </span>
                </ion-col>
              </div>
            </ion-col>
            <ion-col size="5" class="ion-text-right">
              <ion-label>Status: </ion-label><br>
              {{ selected_visit.flvis_status }}
            </ion-col>
          </ion-row>
          <ion-row v-if="selected_visit.showroom_name!=''">
            <ion-col size="12" size-md="4">
              <span >
                <ion-label>Showroom: </ion-label><br>
                {{ selected_visit.showroom_name }}<br>
              </span>
            </ion-col>
          </ion-row>
          <ion-row v-if="selected_visit.flvis_address!=''">
            <ion-col size="12" size-md="6">
              <div style="display: flex; flex-wrap: wrap">
                <ion-col size="12">
                  <span >
                    <ion-label>Address: </ion-label><br />
                    {{ selected_visit.flvis_address }}
                  </span>
                </ion-col>
              </div>
            </ion-col>
          </ion-row>
          <ion-row v-if="selected_visit.flvis_notes!=''">
            <ion-col size="12" size-md="6">
              <div style="display: flex; flex-wrap: wrap">
                <ion-col size="12">
                  <span >
                    <ion-label>Notes: </ion-label><br />
                    {{ selected_visit.flvis_notes }}
                  </span>
                </ion-col>
              </div>
            </ion-col>
          </ion-row>
          <hr>
          <ion-row style="margin-bottom:10px;border-left: 10px solid red;" v-for="item in selected_visit.items" :key="item.flvisi_id">
            <ion-col size="12" size-md="6">
              <div style="display: flex; flex-wrap: wrap">
                <ion-col size="4" >
                  <ion-label>Status: </ion-label><br />
                  <span>{{ item.flvisi_status }}</span>
                </ion-col>
                <ion-col size="8" >
                  <ion-label>By: </ion-label><br />
                  <span>{{ item.ent_fullname }}</span>
                </ion-col>
                <ion-col size="4">
                  <ion-label>Ref: </ion-label><br />
                  <span>{{ item.flvisi_item_ref }}</span>
                </ion-col>
                <ion-col size="8">
                  <ion-label>Name: </ion-label><br />
                  <span>{{ item.prod_name }}</span>
                </ion-col>
                <ion-col size="12" size-md="6">
                  <ion-label>Description: </ion-label><br />
                  <span>{{ item.flvisi_item_description }}</span>
                </ion-col>
                <ion-col size="12" size-md="6">
                  <ion-label>Dimension: </ion-label><br />
                  <span>{{ item.flvisi_item_dimension }}</span>
                </ion-col>
              </div>
            </ion-col>
            <ion-col size="12" size-md="4" class="ion-text-right">
                <ion-button color="warning" size="small" v-if="item.flvisi_item_options.includes('[TEARSHEET]')" @click="toggle(item,'T')">Tearsheet</ion-button>
                <ion-button color="light" size="small" v-if="!item.flvisi_item_options.includes('[TEARSHEET]')" @click="toggle(item,'T')">No Tearsheet</ion-button>

                <ion-button color="primary" size="small" v-if="item.flvisi_item_options.includes('[SAMPLE]')" @click="toggle(item,'M')">Sample</ion-button>
                <ion-button color="light" size="small" v-if="!item.flvisi_item_options.includes('[SAMPLE]')" @click="toggle(item,'M')">No Sample</ion-button>

                <ion-button color="success" size="small" v-if="item.flvisi_item_options.includes('[QUOTE]')" @click="toggle(item,'Q')">Quote</ion-button>
                <ion-button color="light" size="small" v-if="!item.flvisi_item_options.includes('[QUOTE]')" @click="toggle(item,'Q')">No Quote</ion-button>
            </ion-col>
          </ion-row>
        </ion-grid>

        <ion-grid v-if="selected_visit_images.length>0">
          <ion-row>
            <ion-col>
              <ion-list>
                <ion-item v-for="image in selected_visit_images" :key="image">
                  <img style="height: auto" :src="image" />
                  <br />
                </ion-item>
              </ion-list>
            </ion-col>
          </ion-row>
        </ion-grid>

      </div>
    </div>
  </base-layout>
</template>

<script>
import {
  // IonInput,
  IonInfiniteScroll,
  IonInfiniteScrollContent,
  IonItem,
  IonLabel,
  IonList,
  IonGrid,
  IonRow,
  IonCol,
  IonButton,
  IonIcon,
  IonSelect,
  IonSelectOption,
  IonSearchbar,
  IonToggle
} from "@ionic/vue";
import { searchOutline, eyeOutline } from "ionicons/icons";

export default {
  components: {
    // IonInput,
    IonInfiniteScroll,
    IonInfiniteScrollContent,
    IonItem,
    IonLabel,
    IonList,
    IonGrid,
    IonRow,
    IonCol,
    IonButton,
    IonIcon,
    IonSelect,
    IonSelectOption,
    IonSearchbar,
    IonToggle
  },

  data() {
    return {
      status: "Search",
      searchStatus: "All Statuses",
      getAllVisits: false,

      statusList: [
        "All Statuses",
        "InProgress",
        "Finished",
        "Processing",
        "Complete",
        "Cancelled",
      ],

      term: "",
      limit: 20,
      offset: 0,
      show_scroll: false,

      error: "",
      visits: [],
      selected_visit: "",
      selected_visit_images:[],

      searchOutline,
      eyeOutline,
    };
  },

  methods: {
    searchStringFn() {
      this.visits = [];
      this.limit = 20;
      this.offset = 0;
      this.show_scroll = true;
      this.loadData(this.$event,false,false);
    },
    statusFilterFn({ detail }) {
      // console.log(detail);
      // console.log('Search Status:'+detail.value);
      this.searchStatus = detail.value;
      this.term = "";
      this.visits = [];
      this.limit = 20;
      this.offset = 0;
      this.show_scroll = true;
      this.loadData(this.$event,false,false);
    },
    getAllVisitsToggle({ detail }) {
      console.log(detail);
      // console.log('Search Status:'+detail.value);
      this.getAllVisits = detail.checked;
      this.term = "";
      this.visits = [];
      this.limit = 20;
      this.offset = 0;
      this.show_scroll = true;
      this.loadData(this.$event,false,false);
    },
    async loadData(event, call_event,inc_offset=true) {
      console.log("Load data");

      if (inc_offset) {
        this.offset += this.limit;
      }
      await this.$store.dispatch("visits/request_for_visits", {
        term: this.term,
        limit: this.limit,
        offset: this.offset,
        status: this.searchStatus,
        getAllVisits: this.getAllVisits
      });
      var error = this.$store.getters["visits/getRequestError"];

      if (error != "") {
        this.error = error;
      } else {
        let received_visits = this.$store.getters["visits/getAllVisits"];
        for (let i = 0; i < received_visits.length; i++) {
          this.visits.push(received_visits[i]);
        }

        if (received_visits.length < this.limit) {
          this.show_scroll = false;
        }

        this.error = "";
      }

      if (call_event) event.target.complete();
    },

    show_visit(index) {
      // set the visit
      this.selected_visit = this.visits[index];
      // console.log(this.selected_visit);

      // set the images
      this.selected_visit_images = [];
      if(this.selected_visit.persons.length>0){
        let person = this.selected_visit.persons[0];
        if (person.flvisp_images != "" && person.flvisp_images != "null") {
          let person_images = JSON.parse(person.flvisp_images);
          for (let i = 0; i < person_images.length; i++) {
            this.selected_visit_images.push(
              process.env.VUE_APP_API_IMAGES_ENDPOINT + person_images[i].filename
            );
          }
          this.get_business_card_message = "+ Add Card";
        }
      }

      this.status = "Visit_Information";
    },

    continue_visit(index) {
      this.selected_visit = this.visits[index];
      console.log(this.selected_visit);
      this.$store.commit('visits/setCurrentVisitId', { flvis_id:this.selected_visit.flvis_id });
      let person = this.selected_visit.persons[0];
      this.$store.commit('visits/setCurrentVisitPerson', { flvisp_id:person.flvisp_id,
                                                            flvisp_first_name:person.flvisp_first_name,
                                                            flvisp_last_name:person.flvisp_last_name,
                                                            flvisp_company:person.flvisp_company,
                                                            flvisp_email:person.flvisp_email,
                                                            flvisp_phone:person.flvisp_phone,
                                                            flvisp_website:person.flvisp_website,
                                                            flvisp_images:person.flvisp_images });

      this.$store.commit('visits/emptySelectedItems'); // empty previous items

      for( let i=0; i<this.selected_visit.items.length; i++ ){
        let item = this.selected_visit.items[i];

        item.tearsheet_checked = false;
        if(item.flvisi_item_options.includes('[TEARSHEET]'))
          item.tearsheet_checked = true;

        item.memo_checked = false;
        if(item.flvisi_item_options.includes('[SAMPLE]'))
          item.memo_checked = true;

        item.quote_checked = false;
        if(item.flvisi_item_options.includes('[QUOTE]'))
          item.quote_checked = true;

        item.item_note = item.flvisi_notes;
        item.master_conn_id = item.conn_id;

        this.$store.commit('visits/insertSelectedItem', item);
      }

      this.$store.commit('visits/editVisitFlag'); // Raise the flag, so NewVisit loads the data.

      this.$router.push({ name:'NewVisit' });

    },

    back_to_search() {
      this.status = "Search";
    },
  },

  ionViewDidEnter(){
    console.log('New Visit page did enter');

    this.term = "";
    this.visits = [];
    this.limit = 20;
    this.offset = 0;
    this.show_scroll = true;
    let ref = this;

    this.$store.dispatch("visits/request_for_visits", {
        term: this.term,
        limit: this.limit,
        offset: this.offset,
        status: this.searchStatus
      }).then(response => {
        ref.error = '';
        this.visits = response.data.results;
    }, request_error => {
        ref.error = request_error;
    })
  }

};
</script>
<style lang="scss" scoped>

.results {

  font-size: 0.9em;

  ion-col {
    font-size: 0.9em;
  }

  .conf-name {
    color: #000;
  }

  ion-row {
    background: #ffffff;
    /*     margin-bottom: 10px; */
    padding: 10px;
    border-left: 10px solid #226391;
    height: auto;
  }

  .no-date {
    font-style: italic;
  }

  a {
    text-decoration: none;
  }

  ion-grid {
    height: auto;
  }

  ion-item {
    border: none;
    padding: 0px;
  }

  .item-native {
    padding: 0px;
    padding-inline: 0px;
  }

  .item-inner {
    padding: 0px;
    padding-inline: 0px;
    border: none;
  }

  ion-label {
    font-size: 0.8em;
    font-weight: bold;
    color: #444;
  }
}

.information {

  font-size:0.9em;

  .conf-name {
    color: #000;
  }

  ion-row {
    background: #ffffff;
/*     margin-bottom: 10px; */
    padding: 10px;
    border-left: 10px solid #079602;
    height: auto;
  }

  .no-date {
    font-style: italic;
  }

  a {
    text-decoration: none;
  }

  ion-grid {
    height: auto;
  }

  ion-item {
    border: none;
  }

  ion-label {
    font-size: 0.8em;
    font-weight: bold;
    color: #444;
  }

}

.login_error {
  color: red;
  font-size: 15px;
}

ion-toggle {
  zoom: 0.8;
}

</style>